import { WebpackSharedScopes, WebpackSharedScopesOptions } from './types'

const getSharedScopes = (): WebpackSharedScopes | undefined => {
  // @ts-expect-error
  // eslint-disable-next-line camelcase
  return __webpack_share_scopes__ as WebpackSharedScopes | undefined
}

const initializeSharedScopes = async (): Promise<void> => {
  // @ts-expect-error
  // eslint-disable-next-line camelcase
  await __webpack_init_sharing__(WebpackSharedScopesOptions.Default)
}

const areSharedScopesInitialized = (): boolean =>
  getSharedScopes()?.[WebpackSharedScopesOptions.Default] !== undefined

export const ensureSharedScopeAreActive = async (): Promise<WebpackSharedScopes> => {
  if (!areSharedScopesInitialized()) await initializeSharedScopes()
  return getSharedScopes() as WebpackSharedScopes
}
